import React from 'react';
import { Route, Switch, Prompt } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';

import LoginView from '../components/Steps/Login/LoginView';
import ContactView from '../components/Steps/Contact/ContactView';
import OtpView from '../components/Steps/Otp/OtpView';
import ConfirmView from '../components/Steps/Confirm/ConfirmView';
import ResetView from '../components/Steps/Reset/ResetView';
import LetterRouter from './LetterRouter';
import ChoiceRouter from './ChoiceRouter';
import ErrorPage from '../components/Errors/ErrorPage';

function AppRouter() {
  function handleBlockedNavigation(location, action) {
    const { pathname } = location;
    if (action === 'POP') {
      if (
        pathname === '/otc' ||
        pathname === '/password' ||
        pathname === '/contact' ||
        pathname === '/confirm'
      ) {
        return false;
      }
    }
    return true;
  }

  return (
    <>
      <Prompt
        message={handleBlockedNavigation}
      />
      <Switch>
        <Route path="/ident">
          <LoginView />
        </Route>
        <ProtectedRoute path="/choice">
          <ChoiceRouter />
        </ProtectedRoute>
        <ProtectedRoute path="/letter">
          <LetterRouter />
        </ProtectedRoute>
        <ProtectedRoute path="/otc">
          <OtpView />
        </ProtectedRoute>
        <ProtectedRoute path="/password">
          <ResetView />
        </ProtectedRoute>
        <ProtectedRoute path="/contact">
          <ContactView />
        </ProtectedRoute>
        <ProtectedRoute path="/confirm">
          <ConfirmView />
        </ProtectedRoute>
        <Route path="/error">
          <ErrorPage />
        </Route>
      </Switch>
    </>
  );
}

export default AppRouter;
